import { Context } from '@vue-storefront/core';

const shopViewCache = {
    // "key1": {
    //     "localhost:3311": {
    //         data: {},
    //         expire: 0
    //     },
    //     "127.0.0.1:3311": {
    //         data: {},
    //         expire: 0
    //     }
    // },
    // "key2": {
    //     "localhost:3311": {
    //         data: {},
    //         expire: 0
    //     },
    //     "127.0.0.1:3311": {
    //         data: {},
    //         expire: 0
    //     }
    // },
};
function clearData() {
    for (var key in shopViewCache) {
        for (var host in shopViewCache[key]) {
            if (shopViewCache[key][host].expire < Date.now()) {
                delete shopViewCache[key][host];
            }
        }
    }
}
function getCache(ctx: Context, key: string) {
    // console.log('=========getCache=========', key, ctx.req.rawHeaders)
    // return null;

    if (!shopViewCache[key]) {
        return null;
    }
    var host = getLocale(ctx);
    if (!host) {
        return null;
    }

    const cache = shopViewCache[key][host];
    if (cache && cache.expire > Date.now()) {
        // console.log('=========getCache=========', host, key)
        return cache.data;
    } else {
        clearData();
    }
    return null;
}

function setCache(ctx: Context, key: string, data: any, ttl = 1000 * 60 * 5) {
    // return null;

    if (!shopViewCache[key]) {
        shopViewCache[key] = {};
    }
    var host = getLocale(ctx);
    if (!host) {
        return;
    }
    // console.log('----------setCache-------', host, key)
    shopViewCache[key][host] = {
        data,
        expire: Date.now() + ttl
    };

    // console.log('shopViewCache======', shopViewCache);
}

function getHeaderObj(ctx: Context) {
    const headersObj = {} as any;
    for (let i = 0; i < ctx.req.rawHeaders.length; i += 2) {
        headersObj[ctx.req.rawHeaders[i]] = ctx.req.rawHeaders[i + 1];
    }
    return headersObj;
}

function getLocale(ctx: Context) {
    const headersObj = getHeaderObj(ctx);
    const cookiesObj = getCookies(ctx);
    // console.log('cookiesObj================', cookiesObj['debug']);
    if (cookiesObj['debug']) {
        return null;
    }

    cookiesObj['vsf-locale'] = cookiesObj['vsf-locale'] || '-';
    cookiesObj['vsf-currency'] = cookiesObj['vsf-currency'] || '-';

    return headersObj.Host + "/" + cookiesObj['vsf-locale'] + "/" + cookiesObj['vsf-currency'];
}

function getCookies(ctx: Context) {
    const headersObj = getHeaderObj(ctx);
    // console.log('## getCookies ## headersObj================', headersObj);
    var cookieString = headersObj['Cookie'] || headersObj['cookie'];
    var cookieObj = {};
    if (cookieString) {
        var cookies = cookieString.split('; ');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].split('=');
            cookieObj[decodeURIComponent(cookie[0])] = decodeURIComponent(cookie[1]);
        }
    }

    return cookieObj;
}

export default {
    setCache,
    getCache
} 